import { request, METHOD } from '@/utils/request';

export async function getUser(userName) {
    return request('/personAuthManage/getUser', METHOD.POST, {
        userName: userName
    });
}

export async function getUserPostInfo(userId) {
    return request('/personAuthManage/getUserPostInfo', METHOD.POST, {
        userId
    });
}

export async function getMenuDataByUserId(userId) {
    return request('/personAuthManage/getMenuDataByUserId', METHOD.POST, {
        userId: userId
    });
}
export async function getUnUseMenuData(userId) {
    return request('/personAuthManage/getUnUseMenuData', METHOD.POST, {
        userId
    });
}

export async function editUserMenu(userId, menuLists) {
    return request('/personAuthManage/editUserMenu', METHOD.POST, {
        userId: userId,
        menuLists: menuLists
    });
}

export async function getDictNotTreeByCateId(id) {
    return request('/personArchivesController/getDictNotTreeByCateId', METHOD.POST, {
        id
    });
}
export async function getDictTreeByCateId(id) {
    return request('/personArchivesController/getDictTreeByCateId', METHOD.POST, {
        id
    });
}

export async function savePersonnel(form) {
    return request('/personArchivesController/savePersonnel', METHOD.POST, {
        personnelEntity: form
    });
}

export async function editPersonnel(form) {
    return request('/personArchivesController/editPersonnel', METHOD.POST, {
        personnelEntity: form
    });
}

export async function getPersonnelList(departCode, name, mobile) {
    return request('/personArchivesController/getPersonnelList', METHOD.POST, {
        departCode: departCode,
        name: name,
        mobile: mobile
    });
}

export async function getPersonnelDetailById(id) {
    return request('/personArchivesController/getPersonnelDetailById', METHOD.POST, {
        id
    });
}

export async function resetPassWord(form) {
    return request('/personArchivesController/resetPassWord', METHOD.POST, {
        personnelEntity: form
    });
}

export async function changeStatus(form) {
    return request('/personArchivesController/changeStatus', METHOD.POST, {
        personnelEntity: form
    });
}

export async function exportExcel(departCode, name, mobile) {
    return request('/personArchivesController/exportExcel', METHOD.POST, {
        departCode: departCode,
        name: name,
        mobile: mobile
    });
}

export async function getPositionList(postname, status) {
    return request('/positionController/getPositionList', METHOD.POST, {
        postName: postname,
        status: status
    });
}

export async function addPosition(postname, sortnum, describe) {
    return request('/positionController/addPosition', METHOD.POST, {
        postName: postname,
        sortNum: sortnum,
        describe: describe
    });
}

export async function changePostStatus(postid, status) {
    return request('/positionController/changePostStatus', METHOD.POST, {
        postId: postid,
        status: status
    });
}

export async function editPostStatus(postid, postname, sortnum, status, describe) {
    return request('/positionController/editPostStatus', METHOD.POST, {
        postId: postid,
        postName: postname,
        sortNum: sortnum,
        status: status,
        describe: describe
    });
}
// 下载文件
export async function downloadFile(params) {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
  
  const response = await fetch('/api/salaryController/downloadFile', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify(params)
  });

  if (response.ok) {
    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition');
    let filename = 'downloaded_file';
    
    if (disposition && disposition.indexOf('filename=') !== -1) {
      filename = disposition.substring(disposition.indexOf('filename=') + 9);
    } else if (params.relativePath) {
      filename = params.relativePath.split('/').pop();
    }
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } else {
    throw new Error('文件下载失败');
  }
}
